import script from "./Noshu.vue?vue&type=script&setup=true&lang=js"
export * from "./Noshu.vue?vue&type=script&setup=true&lang=js"

import "./Noshu.vue?vue&type=style&index=0&id=e10b8c04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e10b8c04"]])

export default __exports__